import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';

class CitySelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            address: '',
            onSelectHandler: props.onSelect
        };
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = (address, placeId) => {
        this.setState({ address: address });
        var res = address.split(",");
        var city = res.length > 2 ? res[res.length-3] : res[0];
        var region =  res.length > 2 ? res[res.length-2] : res[0];
        var country = res[res.length-1];
        var ctx = this;
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(function(results) {
                ctx.state.onSelectHandler({
                    lat: results.lat,
                    lon: results.lng,
                    location: address.trim(),
                    city: city.trim(),
                    region: region != null ? region.trim() : null,
                    country: country.trim()
                });
            })
            .catch(error => console.error('Error', error));
    };

    searchoptions = {
        type: "(cities)"
    };

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item>
                    <PlacesAutocomplete
                        value={this.state.address}
                        onChange={this.handleChange}
                        onSelect={this.handleSelect}
                        highlightFirstSuggestion={true}
                        debounce={500}
                        searchOptions={this.searchoptions}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <TextField label="City" fullWidth
                                    {...getInputProps({
                                        placeholder: 'Search Cities ...',
                                        className: 'location-search-input',
                                    })}
                                />
                                <div className="autocomplete-dropdown-container">
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                </Grid>
            </Grid>
        );
    }
}
export default CitySelector;
